/**
 * Created by andrewstirling on 4/5/17.
 */

module.exports = {
  uat: "https://globalconfig.dev-bluedot.com/",
  prod: "https://globalconfig.bluedot.io/"
};
